"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _TimezoneTypes = _interopRequireDefault(require("../constants/TimezoneTypes"));

var _formatShortDate = _interopRequireDefault(require("../utils/formatShortDate"));

var _formatMediumDate = _interopRequireDefault(require("../utils/formatMediumDate"));

var _formatShortMonthYear = _interopRequireDefault(require("../utils/formatShortMonthYear"));

var _formatMediumMonthYear = _interopRequireDefault(require("../utils/formatMediumMonthYear"));

var _formatShortQuarterYear = _interopRequireDefault(require("../utils/formatShortQuarterYear"));

var _formatShortFullDate = _interopRequireDefault(require("../utils/formatShortFullDate"));

var _formatMediumFullDate = _interopRequireDefault(require("../utils/formatMediumFullDate"));

var extraFormats = {
  'short-date': _formatShortDate.default,
  'medium-date': _formatMediumDate.default,
  'short-full-date': _formatShortFullDate.default,
  'medium-full-date': _formatMediumFullDate.default,
  'short-m-y': _formatShortMonthYear.default,
  'medium-m-y': _formatMediumMonthYear.default,
  'short-q-y': _formatShortQuarterYear.default
};

var _default = (0, _createReactClass.default)({
  displayName: "FormattedDateTime",
  propTypes: {
    format: _propTypes.default.string,
    type: _propTypes.default.oneOf([_TimezoneTypes.default.PORTAL, _TimezoneTypes.default.USER, _TimezoneTypes.default.UTC]).isRequired,
    value: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.number, _propTypes.default.array]).isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      type: _TimezoneTypes.default.PORTAL
    };
  },
  render: function render() {
    var _this$props = this.props,
        value = _this$props.value,
        format = _this$props.format,
        type = _this$props.type;
    var specialFormatter = extraFormats[format];
    var date = '';

    if (specialFormatter) {
      date = specialFormatter(value, type);
    } else {
      date = _I18n.default.moment[type](value).format(format);
    }

    return _react.default.createElement("span", null, date);
  }
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/components/FormattedDateTime.js
// module id = 173
// module chunks = 209 210 211 212